function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Promise from 'bluebird';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Prompt } from 'react-router-dom';
import resizeImage from './resizeImage';
const resizeWrapper = (UploadComponent, imageResizer = resizeImage) => {
  class ResizedUploader extends Component {
    static getDerivedStateFromProps(nextProps, prevState) {
      const loadingStatus = nextProps.loading || prevState.resizing;
      if (loadingStatus === prevState.loading) {
        return null;
      }
      return {
        loading: loadingStatus
      };
    }
    constructor(props) {
      super(props);
      this.state = {
        resizing: false,
        loading: false
      };
      this.processUpload = this.processUpload.bind(this);
    }
    async processUpload(files) {
      // If no files passed in then don't resize
      if (!Array.isArray(files) || files.length === 0) {
        return;
      }
      const {
        onUpload,
        notificationActions
      } = this.props;
      this.setState({
        resizing: true
      });
      // Need to delay the resize image call to give the modal 450 ms to go through its transitions
      // because as soon as we call resizeImage, the UI will be blocked until the images are resized
      setTimeout(async () => {
        try {
          const resized = await Promise.mapSeries(files, imageResizer);
          this.setState({
            resizing: false
          });
          onUpload(resized);
        } catch (_unused) {
          this.setState({
            resizing: false
          });
          // console.log(`Error processing upload: ${e.message}`);
          notificationActions.error({
            message: 'Failed processing upload. Please try again.',
            rightButtonLabel: 'OK'
          });
        }
      }, 600);
    }
    render() {
      const {
        loading,
        resizing
      } = this.state;
      const {
        notificationActions
      } = this.props;
      const props = _objectSpread(_objectSpread({}, this.props), {}, {
        loading,
        onUpload: this.processUpload
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Prompt, {
        when: resizing,
        message: () => {
          notificationActions.info({
            message: 'Please wait for your image to finish resizing.',
            id: 'transition_while_resizing'
          });
          return false;
        }
      }), /*#__PURE__*/React.createElement(Modal, {
        isOpen: resizing,
        className: "t-rw-modal"
      }, /*#__PURE__*/React.createElement(ModalHeader, null, "Preparing Image(s) for Upload"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("h5", null, "Please wait while we prepare the images for upload."))), /*#__PURE__*/React.createElement(UploadComponent, props));
    }
  }
  ResizedUploader.propTypes = {
    onUpload: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    notificationActions: PropTypes.shape({
      info: PropTypes.func,
      error: PropTypes.func
    }).isRequired
  };
  return ResizedUploader;
};
export default resizeWrapper;